(() => {
  const setup = () => document.querySelectorAll('[data-nf-guide]').forEach(guide => {
    if (guide.dataset.ready) return;
    guide.dataset.ready = 'true';
    const planner = guide.querySelector('[data-nf-planner]');
    const purpose = guide.querySelector('[data-nf-purpose]');
    const choices = Array.from(guide.querySelectorAll('[data-nf-choice]'));
    const checks = Array.from(guide.querySelectorAll('[data-nf-check]'));
    const progress = guide.querySelector('[data-nf-progress]');
    const selectChoice = () => choices.forEach(choice => {
      choice.hidden = choice.dataset.nfChoice !== purpose.value;
    });
    purpose.addEventListener('change', selectChoice);
    selectChoice();
    const updateProgress = () => {
      progress.textContent = planner.dataset.progress.replace('__COUNT__', checks.filter(check => check.checked).length);
    };
    checks.forEach(check => check.addEventListener('change', updateProgress));
    updateProgress();
    const add = guide.querySelector('[data-nf-add]');
    const inquiry = guide.closest('.nr-wrap')?.querySelector('textarea[name="contact[body]"]');
    if (inquiry) {
      add.hidden = false;
      add.addEventListener('click', () => {
        const selected = purpose.options[purpose.selectedIndex].textContent.trim();
        const checked = checks.filter(check => check.checked).map(check => check.value);
        const lines = [planner.dataset.brief + ': ' + guide.dataset.title, selected];
        if (checked.length) lines.push(planner.dataset.checked + ': ' + checked.join('; '));
        const brief = lines.join('\n');
        if (!inquiry.value.includes(brief)) inquiry.value = [inquiry.value.trim(), brief].filter(Boolean).join('\n\n');
        inquiry.dispatchEvent(new Event('input', { bubbles: true }));
        guide.querySelector('[data-nf-status]').textContent = planner.dataset.added;
        inquiry.focus({ preventScroll: true });
        inquiry.scrollIntoView({ block: 'center', behavior: 'auto' });
      });
    }
    const zoom = guide.querySelector('[data-nf-zoom]');
    const dialog = guide.querySelector('[data-nf-dialog]');
    if (zoom && dialog && typeof dialog.showModal === 'function') {
      zoom.hidden = false;
      zoom.addEventListener('click', () => {
        const img = dialog.querySelector('[data-nf-zoom-image]');
        if (!img.hasAttribute('src')) img.src = img.dataset.src;
        dialog.showModal();
      });
      dialog.addEventListener('click', event => {
        if (event.target === dialog) {
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        }
      });
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
